<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          robots.txtにクロール回避の指示が記入されています。
        </p>
        <p v-else>
          robots.txtにクロール回避の指示が記入されておりません。
        </p>
      </div>
    </li>
    <li v-if="crawlAvoidancePages.length" class="c-list--checkup__item">
      <span class="c-list--checkup__label detail">内容</span>
      <div class="c-list--checkup__content">
        <p>
          Webサイトのrobots.txtには以下のページがクローラーがアクセスできないように設定されています。
        </p>
        <dl>
          <dt>Disallow</dt>
          <dd>
            <ul class="c-list--disc">
              <li v-for="(item, index) in crawlAvoidancePages" :key="index">
                {{ item }}
              </li>
            </ul>
          </dd>
        </dl>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <p>
          Webサイトでクロールが必要のないページ・ディレクトリがある場合はrobots.txtに「Disallow：ディレクトリ名」の指示を記入しましょう。<br />例）CMSの管理画面や限定的なユーザーしか閲覧できないようなページ
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    crawlAvoidancePages() {
      if (this.detail.avoidancePage) {
        return this.detail.avoidancePage.filter(item => item);
      }
      return [];
    }
  }
};
</script>
